export const GET_ISSUER_ACCOUNTS_START = "GET_ISSUER_ACCOUNTS_START";
export const GET_ISSUER_ACCOUNTS_FAIL = "GET_ISSUER_ACCOUNTS_FAIL";

export const GET_ISSUER_ACCOUNTS = "GET_ISSUER_ACCOUNTS";
export const GET_ISSUER_ACCOUNTS_SUCCESS = "GET_ISSUER_ACCOUNTS_SUCCESS";

export const GET_ISSUER_ACCOUNT = "GET_ISSUER_ACCOUNT";
export const GET_ISSUER_ACCOUNT_SUCCESS = "GET_ISSUER_ACCOUNT_SUCCESS";

export const ISSUER_ACCOUNT_ACTION = "ISSUER_ACCOUNT_ACTION";
export const ISSUER_ACCOUNT_ACTION_RESPONSE = "ISSUER_ACCOUNT_ACTION_RESPONSE";
